import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import guardsReducer from './slices/guardsSlice';
import reportsReducer from './slices/reportsSlice';
import scheduleReducer from './slices/scheduleSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    guards: guardsReducer,
    reports: reportsReducer,
    schedule: scheduleReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store; 